import React from 'react'
import Main from '../../components/Main/Main'
import HeaderBar from '../../components/HeaderBar/HeaderBar';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import useStyles from "./Layout.css"
import BackDrop from '../../components/BackDrop/BackDrop';
import InfoDisplay from '../../components/InfoDisplay/InfoDisplay';
import AlertDialog from '../../components/AlertDialog/AlertDialog';
import { Common } from '../../utils/Common';
import VideoDialog from '../../components/AlertDialog/VideoDialog';
//import NotificationBar from '../../components/NotificationBar/NotificationBar';

export default function Layout(props:any) {
    const classes = useStyles();
    const [isMenuOpen, setisMenuOpen] = React.useState(false);
    const [nofityRequestNumber, setNofityRequestNumber] = React.useState("");
    const propsitems = {
        isMenuOpen,
        setisMenuOpen,
        setNofityRequestNumber
      };

    return (
        <div>
            <HeaderBar {...propsitems}></HeaderBar>
            <NavigationBar {...propsitems}></NavigationBar>   
            <Main {...props} nofityRequestNumber={nofityRequestNumber} setNofityRequestNumber={setNofityRequestNumber}></Main>
            <InfoDisplay></InfoDisplay>
            <BackDrop></BackDrop>
            <AlertDialog></AlertDialog>
            <VideoDialog></VideoDialog>
        </div>
    )
}
